var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pendant-container"},[_c('button',{staticClass:"main",on:{"click":_vm.handleConfirm}},[_c('img',{staticClass:"image",attrs:{"src":require("./images/boost.png"),"alt":"image"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }